import { useState } from "react";
import './styles.css'

function CopyLinkNew({ property }) {
  const [textButton, setTextButton] = useState("Compartir link");

  const copyToClipboard = () => {
    let str = window.location.href;
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setTextButton("Link copiado!");
  };

  return (
    <div className="">
      <button
        onClick={copyToClipboard}
        className="btn button-style small-button microcopy-bold text-white"
      >
        {textButton}
      </button>
    </div>
  );
}

export default CopyLinkNew;
